<script>
export default {
  props: {
    shipper: {
      type: Object,
      required: true,
    },
    recipient: {
      type: Object,
      required: true,
    },
    package: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    countryOptions: {
      type: Array,
      required: true,
    },
    buttonValidate: {
      type: Function,
      required: true,
    },
    _onCoverage: {
      type: Function,
      required: true,
    },
  },
};
</script>

<template>
  <el-row>
    <el-col :span="5" class="col-item col-top">
      <i class="el-icon-map-location icon-step icon-top"></i>
      <div>
        <div>
          <div class="title-item">Origen</div>
          <el-input
            placeholder="C.P."
            v-model="shipper.postal_code"
            size="small"
            :disabled="isLoading"
          >
            <el-select
              v-model="shipper.country_code"
              slot="prepend"
              placeholder=""
              class="input-with-select"
              :disabled="isLoading"
            >
              <el-option
                v-for="item in countryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-input>
        </div>
        <div>
          <el-input
            placeholder="Colonia (Opcional)"
            v-model="shipper.address2"
            type="text"
            class="margin-top-input"
            size="small"
            :disabled="isLoading"
          >
          </el-input>
        </div>
      </div>
    </el-col>

    <el-col :span="5" class="col-item col-top">
      <i class="el-icon-right icon-step icon-top"></i>
      <div>
        <div>
          <div class="title-item">Destino</div>
          <el-input
            placeholder="C.P."
            v-model="recipient.postal_code"
            size="small"
            :disabled="isLoading"
          >
            <el-select
              v-model="recipient.country_code"
              slot="prepend"
              class="input-with-select"
              :disabled="isLoading"
            >
              <el-option
                v-for="item in countryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-input>
        </div>
        <div>
          <el-input
            placeholder="Colonia (Opcional)"
            v-model="recipient.address2"
            type="text"
            class="margin-top-input"
            size="small"
            :disabled="isLoading"
          >
          </el-input>
        </div>
      </div>
    </el-col>

    <el-col :span="8" class="col-item">
      <i class="el-icon-box icon-step"></i>

      <div class="col-item">
        <!-- package length -->
        <el-col :span="8">
          <div class="title-item">Largo (cm)</div>
          <el-input
            placeholder="Largo"
            v-model="package.length"
            size="small"
            type="number"
            :disabled="isLoading"
          >
          </el-input>
        </el-col>
        <!-- package height -->
        <el-col :span="8" class="input-middle">
          <div class="title-item">Alto (cm)</div>
          <el-input
            placeholder="Alto"
            v-model="package.height"
            type="number"
            size="small"
            :disabled="isLoading"
          >
          </el-input>
        </el-col>
        <!-- package width -->
        <el-col :span="8">
          <div class="title-item">Ancho (cm)</div>
          <el-input
            placeholder="Ancho"
            v-model="package.width"
            type="number"
            size="small"
            :disabled="isLoading"
          >
          </el-input>
        </el-col>
      </div>
    </el-col>

    <el-col :span="3" class="col-item">
      <i class="el-icon-takeaway-box icon-step"></i>
      <div>
        <div class="title-item">Peso (kg)</div>
        <el-input
          placeholder="Peso"
          v-model="package.weight"
          type="number"
          size="small"
          :disabled="isLoading"
        >
        </el-input>
      </div>
    </el-col>

    <!-- search -->
    <el-col :span="3" class="col-btn-item">
      <el-button
        type="primary"
        class="btn-quotes"
        size="small"
        @click="_onCoverage"
        :loading="isLoading"
        :disabled="isLoading || !buttonValidate()"
      >
        Cotizar
      </el-button>
    </el-col>
  </el-row>
</template>

<style>
.title-item {
  font-size: 11px;
  font-weight: 600;
  color: #323232;
  margin-bottom: 4px;
}

.margin-top {
  margin-top: 15px;
}

.icon-step {
  font-size: 15px;
  color: #323232;
  margin: 18px 8px 0px 8px;
}

.icon-top {
  margin-top: 25px;
}

.margin-top-input{
  margin-top: 8px;
}

.col-btn-item {
  text-align: center;
}

.col-item {
  display: flex;
  justify-content: left;
  flex-direction: row;
  align-items: center;
}

.col-top {
  align-items: flex-start;
}

.btn-quotes {
  margin-top: 16px;
}

.input-with-select {
  width: 67px;
  color: #323232;
}

.input-middle {
  margin: 0px 2px;
}
</style>
